import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'input[restrict-input]',
    standalone: false
})
export class RestrictInputDirective {
  wireLessNumberOriginalValue = '';

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('restrict-input') restrictValue: string;
  constructor(private _el: ElementRef, private control: NgControl) {
  }

  // Format the phone number
  formatPhone (num) {
    if (num !== undefined && num.length === 10) {
      num = num.slice(0, 3) + '-' + num.slice(3, 6) + '-' + num.slice(6, 10);
    }
    return num;
  }

  @HostListener('input', ['$event']) onInputChange (event) {
    const initialValue = this._el.nativeElement.value;
    switch (this.restrictValue) {
      case 'restrictzipcode':
        this._el.nativeElement.value = initialValue.replace(/[^0-9\-]/g, '');
        break;
      case 'restrictUTFzipcode':
        this._el.nativeElement.value = initialValue.replace(/[^\d]/g, '');
        break;
      case 'securityAnswer':
      case 'restrictOrgId':
        this._el.nativeElement.value = initialValue.replace(/[^A-Z0-9]/gi, '');
        break;
      case 'restrictPassword':
        this._el.nativeElement.value = initialValue.replace(/[^a-z0-9\!\#\^\$\%\*\(\)\+\{\}\?\-\[\]\@]/gi, '');
        break;
      case 'restrictPasswordNew':
        this._el.nativeElement.value = initialValue.replace(/[^a-z0-9\W_]/gi, '').replace(/\s/, '');
        break;
      case 'numberOnly':
      case 'wirelessNumber':
      case 'wirelessNo':
        this._el.nativeElement.value = initialValue.replace(/[^\d]/g, '');
        break;
      case 'dob':
        this._el.nativeElement.value = initialValue.replace(/[^0-9\/]/g, '');
        break;
      case 'restrictEmailforSpace':
        this._el.nativeElement.value = initialValue.replace(/[^A-Z0-9a-z\.\_\-\@]/g, '');
        break;
      case 'restrictFirstnetId':
        this._el.nativeElement.value = initialValue.replace(/[^A-Z0-9a-z\.\_\-\@\:]/g, '');
        break;
      case 'restrictOrgName':
        this._el.nativeElement.value = initialValue.replace(/[^a-z0-9\s\'\-]/ig, '');
        break;
      case 'restrictforName':
        this._el.nativeElement.value = initialValue.replace(/[^0-9a-z\s\'\-]/gi, '');
        break;
      case 'restrictforModalCity':
        this._el.nativeElement.value = initialValue.replace(/[^A-Z\s]/gi, '');
        break;
      case 'restrictforModalEntityName':
        this._el.nativeElement.value = initialValue.replace(/[^a-z0-9\s]/gi, '');
        break;
      case 'restrictAffiliationCode':
        this._el.nativeElement.value = initialValue.replace(/[^A-Z0-9]/ig, '');
        break;
      case 'restrictforOrgName':
        this._el.nativeElement.value = initialValue.replace(/[^0-9a-z\s\'\-\_\!\#\^\$\%\*\(\)\+\&\@]/gi, '');
        break
      default:
        this._el.nativeElement.value = initialValue;
        break;
    }

    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  @HostListener('blur', ['$event']) onInputBlur (event) {
    if (this.restrictValue === 'restrictPassword' || this.restrictValue === 'securityAnswer') {
      this.control.control.setValue(this._el.nativeElement.value);
    }
    if (this.restrictValue === 'wirelessNumber' || this.restrictValue === 'wirelessNo') {
      this.wireLessNumberOriginalValue = this._el.nativeElement.value;
      this._el.nativeElement.value = this.formatPhone(this.wireLessNumberOriginalValue);
    }
  }

  @HostListener('focus', ['$event']) onInputFocus (event) {
    if (this.restrictValue === 'wirelessNumber') {
      this._el.nativeElement.value = this.wireLessNumberOriginalValue;
    }
  }

  @HostListener('keyup', ['$event']) onInputKey (event) {
    if (this.restrictValue === 'restrictEmailforSpace' || this.restrictValue === 'restrictFirstnetId' ||
      this.restrictValue === 'restrictforName' || this.restrictValue === 'restrictAffiliationCode') {
      this.control.control.setValue(this._el.nativeElement.value);
    }
  }

}
